import React from 'react';
import DispatchNoteForm from '../inventory/dispatch/DispatchNoteForm';

export default function PublisherDispatchCreatePage(){
  return (
    <div className="container mt-4">
      <h2>Create Dispatch Note</h2>
      <DispatchNoteForm isPublisher={true} />
    </div>
  );
}
